import cgu from "@/store/modules/public/cgu";
import companies from "@/store/modules/public/companies";
import mountings from "@/store/modules/public/mountings";
import orders from "@/store/modules/public/orders";
import password from "@/store/modules/public/password";
import shortUrls from "@/store/modules/public/shortUrls";
import tokens from "@/store/modules/public/tokens";
import connectedBoxes from "@/store/modules/public/connectedBoxes";

const state = {};

const getters = {};

const mutations = {};

const actions = {};

const modules = {
  cgu,
  companies,
  mountings,
  orders,
  password,
  shortUrls,
  tokens,
  connectedBoxes,
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
};
